import React from 'react';
import { RadioButton, RadioButtonGroup } from 'material-ui';
// How many cities do you operate in?
// We operate in one city/region.  We operate in multiple cities/regions.
// How many properties do you own/manage?
// We own/manage one property.    We own/manage multiple properties.
export default ({ productType, oneOrMulti, updateProps }) => {
  const isAccom = productType === 'Accommodation';
  return (
    <div style={{ marginTop: '30px' }} data-cy="supplierProductTypeRadio">
      <label>What type of supplier are you?</label> <span style={{ color: 'red' }}>*</span><br/><br/>
      <RadioButtonGroup
        name="productType"
        valueSelected={productType}
        onChange={(e, val) => updateProps({ productType: val })}
      >
        <RadioButton data-cy="nonAccom" label="Non-Accommodation (tours, attractions, etc.)" value="Non-Accommodation" />
        <RadioButton label="Accommodation (hotels, apartments, B&Bs, etc.)" value="Accommodation" />
      </RadioButtonGroup>
      <br/>
      {
        productType && (
          <div>
            <label>{isAccom ? 'How many properties do you own/manage' : 'How many cities do you operate in'} ?</label> <span style={{ color: 'red' }}>*</span><br/><br/>
            <RadioButtonGroup
              name="locationNum"
              valueSelected={oneOrMulti}
              onChange={(e, val) => updateProps({ oneOrMulti: val })}
            >
              <RadioButton
                label={isAccom ? 'We own/manage one property.' : 'We operate in one city/region.'}
                value="one"
                data-cy="one-prop"
              />
              <RadioButton
                label={isAccom ? 'We own/manage multiple properties.' : 'We operate in multiple cities/regions.'}
                value="multi"
              />
            </RadioButtonGroup>
          </div>
        )
      }
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/contracting-sign-up/form-part-supplier.jsx